import { render, staticRenderFns } from "./ItsBaseColdStorageInspect.vue?vue&type=template&id=eb9f1dee&scoped=true&"
import script from "./ItsBaseColdStorageInspect.vue?vue&type=script&lang=js&"
export * from "./ItsBaseColdStorageInspect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb9f1dee",
  null
  
)

export default component.exports